import React from 'react';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: designTokens.spacing.lg,
        backgroundColor: designTokens.colors.background.card,
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: designTokens.borderRadius.card,
        marginBottom: '12px',
        '@media (max-width: 600px)': {
            maxHeight: '200px',
            overflow: 'hidden',
        },
    },
    content: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        paddingRight: designTokens.spacing.lg,
    },
    title: {
        ...designTokens.typography.h3,
        flex: 1,
        cursor: 'pointer',
        '&:hover': {
            color: designTokens.colors.primary,
        },
        '@media (max-width: 600px)': {
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: '-0.31px',
            display: '-webkit-box',
            WebkitLineClamp: 8,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    },
    optionsRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    infoIcon: {
        color: designTokens.colors.primary,
        fontSize: '20px',
        cursor: 'pointer',
    },
    deleteButton: {
        padding: '4px',
        marginLeft: '8px',
        minWidth: '28px',
    },
    deleteIcon: {
        color: designTokens.colors.red.main,
        fontSize: '20px',
    },
    priceContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        minWidth: '80px',
    },
    currentPrice: {
        ...designTokens.typography.h4,
    },
    tooltip: {
        backgroundColor: designTokens.colors.background.tooltip,
        color: designTokens.colors.text.primary,
        maxWidth: 500,
        maxHeight: 400,
        overflow: 'auto',
        fontSize: 13,
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: designTokens.borderRadius.card,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        padding: '12px 16px',
        '& h1, & h2, & h3': {
            fontSize: 14,
            fontWeight: 600,
            marginTop: 12,
            marginBottom: 8,
            color: designTokens.colors.primary,
        },
        '& p': {
            marginTop: 8,
            marginBottom: 8,
        },
        '& ul, & ol': {
            paddingLeft: 20,
            marginTop: 8,
            marginBottom: 8,
        },
        '& li': {
            marginBottom: 4,
        },
        '& strong': {
            fontWeight: 600,
            color: designTokens.colors.text.primary,
        },
    }
});

const AssayCartItem = ({
    item,
    onRemove,
    onInfo,
    takeId
}) => {
    const classes = useStyles();

    const displayName = item.name ||
        (item.testNames ? item.testNames.split(',')[0].split('\\\\').join('') : 'Невідомий аналіз');

    const isBiomaterialCollection = +item.idParent === takeId;

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <div className={classes.titleRow}>
                    <span className={classes.title} onClick={() => onInfo(item)}>
                        {displayName}
                    </span>
                </div>

                <div className={classes.optionsRow}>
                    {item.definition && (
                        <Tooltip
                            title={<div dangerouslySetInnerHTML={{ __html: item.definition }} />}
                            placement="top"
                            enterTouchDelay={0}
                            interactive
                            classes={{ tooltip: classes.tooltip }}
                        >
                            <InfoIcon
                                className={classes.infoIcon}
                                onClick={() => onInfo(item)}
                            />
                        </Tooltip>
                    )}
                    <div className={classes.priceContainer}>
                        <span className={classes.currentPrice}>
                            {item.price} грн
                        </span>
                    </div>
                    {!isBiomaterialCollection ? (
                        <IconButton
                            className={classes.deleteButton}
                            onClick={() => onRemove(item)}
                            size="small"
                        >
                            <DeleteIcon className={classes.deleteIcon} />
                        </IconButton>
                    ) : <div className={classes.deleteButton}>&nbsp;</div>}
                </div>
            </div>
        </div>
    );
};

export default AssayCartItem;
